const FAILURE_STATUS = /fail|error|reject|bounce|undelivered|partial/i

export const responseMessage = data =>
  data?.error || data?.message || data?.detail || data?.msg || data?.reason || "Unable to complete the request."

export const responseFromEmail = (data, fallback = "") =>
  data?.from_email || data?.from_address || data?.failed_from_email || data?.smtp_from_email ||
  data?.smtp?.from_email || fallback || ""

export const hasDeliveryFailure = data => {
  if (!data || typeof data !== "object") return false
  if (data.success === false || data.ok === false || data.delivered === false) return true
  const status = data.delivery_status || data.deliveryStatus || data.status || data.result
  return typeof status === "string" && FAILURE_STATUS.test(status)
}

export const isSuccessfulDelivery = (response, statuses = [200, 201, 202]) =>
  statuses.includes(response?.status) && !hasDeliveryFailure(response?.data)

export const deliveryErrorMessage = (data, fallbackFrom = "") => {
  const message = responseMessage(data)
  const fromEmail = responseFromEmail(data, fallbackFrom)
  const smtpMessage = fromEmail
    ? ` SMTP authentication failed for ${fromEmail}. Please verify your SMTP settings.`
    : ""
  return `${message}${smtpMessage}`
}

export const deliverySummary = data => ({
  total: data?.total_recipients ?? data?.recipient_count ?? data?.total ?? 0,
  successful: data?.successful_count ?? data?.success_count ?? data?.sent_count ?? 0,
  failed: data?.failed_count ?? data?.failure_count ?? 0,
  failedRecipients: data?.failed_recipients ?? data?.failures ?? [],
  failureReason: data?.failure_reason || data?.error || data?.message || data?.reason || "",
})

export const deliverySummaryMessage = data => {
  const summary = deliverySummary(data)
  const failedRecipients = Array.isArray(summary.failedRecipients)
    ? summary.failedRecipients.map(item => item?.email || item?.name || item?.recipient || item).filter(Boolean).join(", ")
    : String(summary.failedRecipients || "")
  return [
    `Total recipients: ${summary.total}`,
    `Successful: ${summary.successful}`,
    `Failed: ${summary.failed}`,
    failedRecipients ? `Failed recipients: ${failedRecipients}` : "",
    summary.failureReason ? `Failure reason: ${summary.failureReason}` : "",
  ].filter(Boolean).join("\n")
}

export const hasDeliverySummary = data => [
  "total_recipients", "recipient_count", "successful_count", "success_count",
  "sent_count", "failed_count", "failure_count", "failed_recipients", "failures",
].some(key => data && Object.prototype.hasOwnProperty.call(data, key))
